"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractDomain = exports.getPath = void 0;
var getPath = function () {
    return window.location.pathname;
};
exports.getPath = getPath;
var extractDomain = function (url) {
    // todo: 暂时不考虑 query 等。
    var reg = /\/\/([^/]+)/gm;
    var match = reg.exec(url);
    return (match && match[1]) || '';
};
exports.extractDomain = extractDomain;
